import { render } from "./OrderUploadPop.vue?vue&type=template&id=f34f0850"
import script from "./OrderUploadPop.vue?vue&type=script&lang=js"
export * from "./OrderUploadPop.vue?vue&type=script&lang=js"

import "./OrderUploadPop.vue?vue&type=style&index=0&id=f34f0850&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__